import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-[60vh] gap-6 text-center px-6">
      <div className="absolute top-6 left-6">
        <Button asChild variant="ghost" size="sm" className="gap-1 text-muted-foreground">
          <Link to="/"><ChevronLeft size={16} />Home</Link>
        </Button>
      </div>
      <h1 className="text-8xl font-bold text-muted-foreground/30">404</h1>
      <div className="space-y-2">
        <p className="text-2xl font-semibold">Page not found</p>
        <p className="text-muted-foreground max-w-sm">
          The page you&apos;re looking for doesn&apos;t exist or may have been moved.
        </p>
      </div>
      <div className="flex gap-3">
        <Button asChild>
          <Link to="/">Go Home</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/dashboard">Go to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
